import { gql } from '@apollo/client'

export const Query = gql`
  query EditCategory($companyId: ID!, $filters: CategoryFilters) {
    categories(companyId: $companyId, filters: $filters) {
      nodes {
        id
        name
        fullname
        color
        parent { id fullname color }
        mystroTestId
      }
    }
  }
`
